import { render, staticRenderFns } from "./Pictogram.vue?vue&type=template&id=13a18070&"
import script from "./Pictogram.vue?vue&type=script&lang=js&"
export * from "./Pictogram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports